<template>
  <div class="expert-jion">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>

    <div class="expert-jion-wrap">
      <!-- 活动名称 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 134px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          姓名
        </div>
        <div class="userinput" style="float: left">
          <input type="text" placeholder="请输入姓名" ref="activityName" />
        </div>
      </div>
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 134px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          手机号码
        </div>
        <div class="userinput" style="float: left">
          <input type="text" placeholder="请输入手机号码" ref="activityName" />
        </div>
      </div>
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 134px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          身份证号
        </div>
        <div class="userinput" style="float: left">
          <input type="text" placeholder="请输入身份证号" ref="activityName" />
        </div>
      </div>
            <!-- 人数 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 134px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          退役证号
        </div>
        <div class="userinput" style="float: left">
          <input
            type="text"
            placeholder="请输入退役证号"
            ref="planNum"
          />
        </div>
      </div>

      <!-- 清除浮动 -->
      <div style="clear: both"></div>
      <!-- 活动图片 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 134px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          证件照片
        </div>
        <div style="width: 400px; overflow: hidden; float: left">
          <div style="width: 100%; overflow: hidden">
            <el-upload
              class="avatar-uploader"
              action="/v1/cloud/user/expert/upload/img"
              :show-file-list="false"
              :on-success="handleSuccess2"
              :on-error="handleError2"
              :before-upload="beforeAvatarUpload2"
            >
              <img v-if="coverImage" :src="coverImage" class="avatar" />
              <div style="width: 170px; height: 100px" v-show="!coverImage">
                <img
                  src="../static/common/upload_image.png"
                  style="
                    dispaly: block;
                    width: 34px;
                    height: 33px;
                    margin: 0px 67px;
                    position: absolute;
                    left: 0px;
                    top: 24px;
                  "
                />
                <div
                  style="
                    color: #3476C1;
                    position: absolute;
                    left: 0px;
                    top: 24px;
                    width: 170px;
                    text-align: center;
                  "
                >
                  点击此处上传
                </div>
              </div>
            </el-upload>
            <!-- <div style="width:218px;float:left;height:100px;margin-left:10px;">
                        <div style="font-size:12px;line-height:12px;margin-top:43px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(154,154,154,1);">logo 为非必填项</div>
                    </div> -->
            <div
              style="
                width: 218px;
                float: left;
                height: 100px;
                margin-left: 10px;
              "
              v-show="!coverImage"
            >
              <div
                style="
                  font-size: 12px;
                  line-height: 12px;
                  margin-top: 43px;
                  font-family: MicrosoftYaHei;
                  font-weight: 400;
                  color: rgba(154, 154, 154, 1);
                "
              >
                可上传png、jpg、gif、svg等格式的文件
              </div>
            </div>
            <div
              style="
                width: 218px;
                float: left;
                height: 100px;
                margin-left: 10px;
              "
              v-show="coverImage"
            >
              <div
                style="
                  font-size: 12px;
                  line-height: 12px;
                  margin-top: 33px;
                  font-family: MicrosoftYaHei;
                  font-weight: 400;
                  color: rgba(154, 154, 154, 1);
                "
              >
                可上传png、jpg、gif、svg等格式的文件
              </div>
              <div
                style="
                  font-size: 12px;
                  line-height: 12px;
                  margin-top: 10px;
                  font-family: MicrosoftYaHei;
                  font-weight: 400;
                  color: rgba(154, 154, 154, 1);
                "
              >
                如需更换图片，请点击图片可再次上传
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 134px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          退役证号
        </div>
        <div class="userinput2" style="float: left">
          <el-radio-group v-model="radio">
            <el-radio :label="3">备选项</el-radio>
            <el-radio :label="6">备选项</el-radio>
            <el-radio :label="9">备选项</el-radio>
        </el-radio-group>
        </div>
      </div>
      <div class="go" @click="submitFn()">提交</div>
    </div>

    <div style="width: 100%; height: 50px"></div>
  </div>
</template>

<script>
// import helloworld from '@/components/helloworld.vue' //引入组件
import navigation from "@/components/common/navigation";

import areasData from "@/assets/areas.json";

export default {
  name: "activity-upload",
  components: {
    navigation,
  },
  data() {
    return {
      radio: 3,
      userInfor: {},
    //   img1: require("../static/login/i6.png"), //单选图标
    //   img2: require("../static/login/i7.png"),
      isOr1: 1, //是否
      isOr2: 1, //是否
      isOr3: 1, //是否
      isOr4: 1, //是否
      industryList: [],

      fileList: [],
      uploadList: [],
      resFileUrl: "",
      coverImage: "",
      uploadCover: "",
      sel_territory: "",
      sel_qualifications: "",
      sel_politic: "",
      individualResume: "", //简介
      individualResume2: "", //详情
      agreementFlag: 0,
      //省市区数据
      provinceArr: areasData.data,
      cityArr: [],
      countyArr: [],
      formValidate: {
        province: "",
        city: "",
        county: "",
      },
      defaultAddress: {
        province: "请选择",
        city: "请选择",
        county: "请选择",
      },
      provinceCode: 0,
      cityCode: 0,
      countyCode: 0, //地区编码

      dateValue1: "", //举办开始时间
      dateValue2: "", //举办结束时间
      dateValue3: "", //报名开始时间
      dateValue4: "", //报名结束时间

      editorContent: "", //富文本内容
    };
  },
  methods: {
    handlePreview(file) {
      console.log(file);
    },
    handleError(err, file, fileList) {
      // console.log('000',err,file, fileList);
      this.$message.error("文件太大，请压缩后上传");
    },
    handleRemove(file, fileList) {
      console.log(111, file, fileList);
      let list = [];
      if (fileList) {
        fileList.forEach((item, index, array) => {
          list.push(item.response);
        });
      }
      this.uploadList = list;
      //删除服务器上文件
      let imgUrl = file.response;
      this.$axios
        .post("/v1/cloud/user/expert/upload/certificate/delete", {
          url,
        })
        .then(({ data }) => {})
        .catch((error) => {
          this.$message.error(error.response.data.message);
        });
    },
    handleError2(res) {
      if (res.status == 401) {
        this.$router.push({ name: "login" });
      } else if (res.status == 400) {
        this.$message.error("文件太大，请压缩后上传");
      }
    },
    handleSuccess(res, file, fileList) {
      console.log(222, res, file, fileList);
      this.resFileUrl = res;
      let list = [];
      if (fileList) {
        fileList.forEach((item, index, array) => {
          list.push(item.response);
        });
      }
      this.uploadList = list;
      console.log(222, this.uploadList, list);
    },
    handleSuccess2(res, file) {
      this.coverImage = URL.createObjectURL(file.raw);
      this.uploadCover = res;
    },
    beforeAvatarUpload2(file) {
      // const isJPG = file.type === 'image/jpeg';
      // const isLt2M = file.size / 1024 / 1024 < 0.2;
      // if (!isJPG) {
      // this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      // if (!isLt2M) {
      // this.$message.error('上传头像图片大小不能超过 2MB!');
      // }
      // return isJPG && isLt2M;
    },
    toExpert() {
      this.$router.push("/Expert");
    },
    isOrFn(type, val) {
      console.log(type);
      if (type == "1") {
        this.isOr1 = val;
      } else if (type == "2") {
        this.isOr2 = val;
      } else if (type == "3") {
        this.isOr3 = val;
      } else if (type == "4") {
        this.isOr4 = val;
      } else if (type === "agreement") {
        if (this.agreementFlag === 1) {
          this.agreementFlag = 0;
        } else {
          this.agreementFlag = 1;
        }
      } else {
      }
    },
    submitFn() {
      let param = {
        name: this.$refs.activityName.value,
        catalogueId: this.sel_territory,
        phoneNum: this.$refs.phoneNum.value,
        coverImg: this.uploadCover, //活动图片
        address: this.$refs.address.value,
        baseRemark: this.individualResume, //简介
        // remark:this.individualResume2,   //详情
        remark: this.editorContent,
        planNum: this.$refs.planNum.value, //人数
        activityStartDateStr: this.dateValue1, //举办开始时间
        activityEndDateStr: this.dateValue2, //举办结束时间
        registerStartDateStr: this.dateValue3, //报名开始时间
        registerEndDateStr: this.dateValue4, //报名结束时间
        provinceCode: this.provinceCode,
        cityCode: this.cityCode,
        areaCode: this.countyCode,
        // registerNum;
        // money;
        // companyName;
        // showHome;
        // registerStartDate
        // registerEndDate;
        // createDate;
        // updateDate;
      };
      console.log("上传项目", param);
      this.$axios
        .post("/v1/cloud/user/activity//upload", param)
        .then(({ data }) => {
          if (data) {
            this.$message({
              showClose: true,
              message: "上传成功，需要1-3个工作日审核信息！",
              type: "success",
            });
            this.$router.push("/activity");
          }
        })
        .catch((error) => {
          var err = error.response;
          if (err.status == 400) {
            this.$Message.error(err.data.message);
          }
          if (err.status == 401) {
            this.$router.push({ name: "login" });
          } else {
            this.$message.error(error.response.data.message);
          }
        });
    },
    changeProvince(val) {
      for (var i = 0; i < this.provinceArr.length; i++) {
        if (this.formValidate.province == this.provinceArr[i].encoded) {
          this.cityArr = this.provinceArr[i].cityRespList;
          this.formValidate.county = "";
          this.countyArr = [];
        }
      }
      this.provinceCode = val;
    },
    changeCity(val) {
      for (var i = 0; i < this.cityArr.length; i++) {
        if (this.formValidate.city == this.cityArr[i].encoded) {
          this.countyArr = this.cityArr[i].countyRespList;
        }
      }
      this.cityCode = val;
    },
    changeCounty(s) {
      console.log("区", s, this.formValidate.county);
      this.countyCode = s;
    },
    //富文本
    toListenUp: function (editor) {
      //监听上传图片的几个阶段，和做相应的处理
      var _this = this;
      editor.customConfig.uploadImgHooks = {
        before: function (xhr, editor, files) {
          // 图片上传之前触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
          // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
          // return {
          //     prevent: true,
          //     msg: '放弃上传'
          // }
        },
        success: function (xhr, editor, result) {
          // 图片上传并返回结果，图片插入成功之后触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
        },
        fail: function (xhr, editor, result) {
          // 图片上传并返回结果，但图片插入错误时触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
        },
        error: function (xhr, editor) {
          // 图片上传出错时触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
        },
        timeout: function (xhr, editor) {
          // 图片上传超时时触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
        },
        customInsert: function (insertImg, result, editor) {
          var url = result.data; //获取后台返回的图片路径
          insertImg(url); //把图片路径展示在编辑器里面
        },
      };
    },
  },
  created() {
    //活动类型
    this.$axios.get("/v1/cloud/common/activity/catalogue").then(({ data }) => {
      if (data) {
        // data.shift()
        this.industryList = data;
      }
    });
    //是否登录校验
    if (!localStorage.token) {
      this.$router.push({ name: "login" });
    }
  },
  mounted() {
    //滚动条从顶部开始
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (osTop > 0) {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
  },
};
</script>

<style lang="less">
::-webkit-input-placeholder {
    color: #999999 !important;
    font-family: MicrosoftYaHei;
}
.ivu-select-selection {
  height: 40px !important;
  line-height: 40px !important;
}
.ivu-select-placeholder,
.ivu-select-selected-value,
.el-input__inner,
.el-date-editor {
  height: 40px !important;
  line-height: 40px !important;
}
//最多上传九个图片
.upload-nine {
  // width:170px;float: left;
  .el-upload-dragger {
    height: 100px;
    border: none;
  }
}
//上传图片
.avatar-uploader .el-upload {
  // border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  text-align: center;
  float: left;
  width: 170px !important;
  height: 100px !important;
  line-height: 100px !important;
  background: rgba(250, 250, 250, 1);
  border: 1px solid rgba(238, 238, 238, 1);
}
.avatar-uploader-l .el-upload {
  margin-left: 8px;
}
// .avatar-uploader .el-upload:hover {
//     border-color: #409EFF;
// }
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 182px;
  height: 115px;
  line-height: 115px;
  text-align: center;
}
.avatar {
  width: 182px;
  height: 115px;
  display: block;
}

input {
  outline: none;
  border: none;
  background: rgba(0, 0, 0, 0);
}
.expert-jion {
  width: 100%;
  .expert-jion-wrap {
    width: 1000px;
    height: auto;
    margin: 0 auto;
    padding-left: 200px;
    margin-top: 50px;
    overflow: hidden;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(238, 238, 238, 1);
    //ele组件
    .date-picker {
      .el-input__inner {
        width: 350px;
        height: 50px;
        background: rgba(250, 250, 250, 1);
        border: 1px solid rgba(238, 238, 238, 1);
        border-radius: 4px;
        padding-left: 9px;
      }
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 350px;
        height: 50px;
      }
      .el-input__icon {
        display: none;
      }
    }
    .userinput2 {
      width: 350px;
      height: 40px;
      display: flex;
      align-items: center;
    }
    .userinput {
      width: 350px;
      height: 40px;
      background: rgba(250, 250, 250, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;
      padding-left: 9px;
      input {
        float: left;
        width: 300px;
        height: 100%;
      }
    }
    .userinfor {
      width: 350px;
      height: 50px;
      line-height: 50px;
      background: rgba(250, 250, 250, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;
      padding-left: 4px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(154, 154, 154, 1);
    }
    //iview 下拉框组件
    .iselect {
      .ivu-select {
        width: 350px !important;
        height: 50px !important;
        line-height: 50px;
      }
      .ivu-select-selection {
        height: 50px;
        line-height: 50px;
        background: rgba(250, 250, 250, 1);
      }
      .ivu-select-single .ivu-select-selection {
        outline: none;
        width: 350px;
        height: 50px;
        line-height: 50px;
      }
      .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
      .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        width: 350px;
        height: 50px;
        line-height: 50px;
      }
    }
    .infor-area {
      .ivu-select-selection {
        height: 50px;
        line-height: 50px;
        background: rgba(250, 250, 250, 1);
      }
      .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
      .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        width: 350px;
        height: 50px;
        line-height: 50px;
        color: #999999;
        width: 110px;
      }
      .ivu-select-single .ivu-select-selection {
        height: 50px;
      }
    }
    .go {
      margin-top: 20px;
      margin-bottom: 50px;
      margin-left: 165px;
      width: 350px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #3476C1;
      border-radius: 4px;
      cursor: pointer;
      font-size: 18px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>